// extracted by mini-css-extract-plugin
export default {"reactionsContainer":"zS0L0I"};